import DocumentsIcon from "@mui/icons-material/LibraryBooksOutlined";
import { IconButton as MuiIconButton, Tooltip } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";

import type { Team } from "@citrine/resources/team";
import { TeamClient } from "@citrine/resources/team";

import { QuerySuspense } from "#src/components/query-suspense";
import { useCatalystContext } from "#src/contexts/catalyst";

import { TEST_IDS } from "./utils";

export function DocumentManagerButton({ teamId }: { teamId?: string }) {
  const teamsQuery = TeamClient.getInstance().useFind({
    per_page: 1,
  });

  const { setExpanded } = useCatalystContext();

  // Redirect to the data managers documents tab if available
  return (
    <QuerySuspense
      queries={[teamsQuery]}
      render={([teams]) => {
        const team =
          teams.find(({ id }) => id === teamId) ??
          (teams[0] as Team | undefined);

        return team ? (
          <Tooltip
            title={
              <FormattedMessage id="catalyst.document-manager.manage-documents" />
            }
          >
            <MuiIconButton
              size="small"
              data-fullstoryid="catalyst.document-manager.redirect-to-data-manager"
              data-testid={TEST_IDS.documentManagerButton}
              component={Link}
              to={`/data-manager/teams/${team.id}/documents`}
              onClick={() => setExpanded(false)}
            >
              <DocumentsIcon />
            </MuiIconButton>
          </Tooltip>
        ) : null;
      }}
    />
  );
}
